
import { useState } from 'react';

import { Button, ListItemText, Typography } from '@mui/material';

import { RiMenuSearchLine } from "react-icons/ri";

import { ListItembuttonStyle, ListItemIconStyle, ListItemTextStyle, ListTypographyStyle } from '../../styles/ListItemStyle';
import { DialogBuscar } from '../../dialogs/DialogBuscar';

export const ListItemBuscar = () => {

    const [openDialogBuscar, setOpenDialogBuscar] = useState(false);

    return (
        <>
        
            <ListItemText style={ ListItemTextStyle }>
        
                <Button color="inherit" style={ ListItembuttonStyle } onClick={ () => setOpenDialogBuscar( true ) }>

                    <RiMenuSearchLine style={{ ...ListItemIconStyle, fontSize: 22 }} />

                    <Typography sx={{ ...ListTypographyStyle, display: { xs: 'none', lg: 'flex' } }} >
                        Buscar
                    </Typography>     

                </Button>

            </ListItemText>

            <DialogBuscar 
                openDialog={ openDialogBuscar }
                handleCloseDialog={ () => setOpenDialogBuscar( false ) }
            />
        
        </>
    )
}